/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions", "../FluxCommon/ActionsHubManager", "./ServicesActions"], function (require, exports, Actions_1, ActionsHubManager_1, ServicesActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServicesActionsCreator = /** @class */ (function (_super) {
        __extends(ServicesActionsCreator, _super);
        function ServicesActionsCreator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ServicesActionsCreator.getKey = function () {
            return "services-actionscreator";
        };
        ServicesActionsCreator.prototype.initialize = function (instanceId) {
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(ServicesActions_1.ServicesActions);
        };
        ServicesActionsCreator.prototype.getServices = function (kubeService) {
            var _this = this;
            kubeService.getServices().then(function (servicesList) {
                _this._actions.servicesFetched.invoke(servicesList);
            });
        };
        return ServicesActionsCreator;
    }(Actions_1.ActionCreatorBase));
    exports.ServicesActionsCreator = ServicesActionsCreator;
});
